import React from "react";

import { ExtractEnumStates } from "0.Mine/1.Hooks/utils/helpers";
import { LeadState } from "0.Mine/3.Interfaces/lead";
import ArgonBox from "components/ArgonBox";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";

const states = ExtractEnumStates(LeadState);

interface CRMFunnelBoardProps {
  newLeads: number; // Changed from newLead to newLeads to match usage
  lost: number;
  appointment: number;
  negotiation: number;
  nonInterested: number;
  contract: number;
}

const CRMFunnelBoard = ({
  newLeads,
  lost,
  appointment,
  negotiation,
  nonInterested,
  contract,
}: CRMFunnelBoardProps) => {
  // Updated parameter name in the destructured props

  return (
    <HorizontalBarChart
      title="Ecco il resoconto delle tue leads"
      chart={{
        labels: states,
        datasets: [
          {
            label: "Funnel State",
            color: "dark",
            data: [newLeads, lost, appointment, negotiation, nonInterested, contract], // Updated variable name here
          },
        ],
      }}
    />
  );
};

export default CRMFunnelBoard;
